import { defineMessages } from "react-intl";
import { stdnum } from "stdnum";

import { removeNonAlphanumeric } from "../tax-information.utils";

const GB_TAX_IDS = {
  NINO: "NINO",
  CRN: "CRN",
};

const GB_TAX_IDS_META = {
  [GB_TAX_IDS.NINO]: {
    type: GB_TAX_IDS.NINO,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.nino_short_name",
        defaultMessage: "NINO",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.nino_name",
        defaultMessage: "National Insurance Number",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.nino_full_name",
        defaultMessage: "National Insurance Number (NINO)",
      },
    }),
    validationFn: stdnum.GB.nino.validate,
    format: "XX 00 00 00 X",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.nino_format",
        defaultMessage: "2 letters, 6 numbers, 1 letter",
      },
    }),
  },
  [GB_TAX_IDS.CRN]: {
    type: GB_TAX_IDS.CRN,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.crn_short_name",
        defaultMessage: "CRN",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.crn_name",
        defaultMessage: "Company Registration Number",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.crn_full_name",
        defaultMessage: "Company Registration Number (CRN)",
      },
    }),
    validationFn: (value) => {
      const validationPattern = /^(?:\d{8}|[A-Za-z]{2}\d{6})$/;
      return {
        isValid: validationPattern.test(value),
        compact: removeNonAlphanumeric(value),
        isIndividual: false,
        isCompany: true,
      };
    },
    format: "XX 000000",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.crn_format",
        defaultMessage: "8-digit or 2 letters followed by 6 digits",
      },
    }),
  },
};

const GB_VAT_IDS = {
  VAT: "VAT",
};

const GB_VAT_IDS_META = {
  [GB_VAT_IDS.VAT]: {
    type: GB_VAT_IDS.VAT,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.vat_short_name",
        defaultMessage: "VAT",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.vat_name",
        defaultMessage: "Value-Added Tax",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.vat_full_name",
        defaultMessage: "Value-Added Tax (VAT)",
      },
    }),
    validationFn: stdnum.GB.vat.validate,
    format: "GB 000 0000 00",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.vat_format",
        defaultMessage: "2 letters, 9 digits",
      },
    }),
  },
};

export { GB_TAX_IDS_META, GB_TAX_IDS, GB_VAT_IDS_META, GB_VAT_IDS };
